const mabRepository = (fetch: CustomFetch) => ({
  async getIdentStatus(sessionId: string): Promise<MabIdentificationStatus> {
    return await fetch<MabIdentificationStatus>(`/v3/mab/${sessionId}/status`)
  },
  /**
   * PAR Request that will generate a URL to start the Identification flow, scoped to a specific signature.
   * Used from the document viewer when a user needs to upgrade their legislation to sign a pending request.
   * When the user is identified, they will be redirected to the 'redirect-ident' page.
   * @param signatureRequestId - ID of the signature request the identification is being performed for
   * @param signatureId - ID of the user's signature within that request
   * @param language - Language preference for the Identification flow
   * @param legislation - Target legislation to upgrade to
   */
  async createIdentParRequest(
    signatureRequestId: string,
    signatureId: string,
    language: string,
    legislation: Legislation
  ) {
    return await fetch<{ url: string }>(`/v3/mab/create-par/ident/${signatureRequestId}/signatures/${signatureId}`, {
      method: 'POST',
      body: { language, legislation },
    })
  },
  /**
   * PAR Request that will generate a URL to start the Identification flow, without a signature context.
   * Used from the profile settings page when a user upgrades their legislation independently of any signing flow.
   * When the user is identified, they will be redirected to the 'redirect-ident' page.
   * @param language - Language preference for the Identification flow
   * @param legislation - Target legislation to upgrade to
   */
  async createStandaloneIdentParRequest(language: string, legislation: Legislation) {
    return await fetch<{ url: string }>('/v3/mab/create-par/ident', {
      method: 'POST',
      body: { language, legislation },
    })
  },
  /**
   * Record user's acceptance of the Terms of Use for the identification flow. Used for logged-in users.
   * @param sessionId - PAR session ID
   */
  async acceptTermsOfUse(sessionId: string): Promise<void> {
    await fetch(`/v3/mab/${sessionId}/accepted-terms`, {
      method: 'POST',
    })
  },
  /**
   * Update the data on backend after the user is redirected back from the Identification flow
   * @param sessionId - Identification session ID
   * @param params - Query parameters passed to and returned from the Identification flow
   * @returns RedirectResponse with the status of the identification
   */
  async redirectIdent(sessionId: string, params: Record<string, string | string[]>): Promise<RedirectResponse> {
    return await fetch<RedirectResponse>(`/v3/mab/redirect-ident/${sessionId}`, {
      method: 'POST',
      body: {
        params,
      },
    })
  },
})

export default mabRepository
